import { useCallback } from 'react'

import { type UseSuspenseQueryResult, useSuspenseQuery } from '@tanstack/react-query'
import { useSearch } from '@tanstack/react-router'

import type { EnrichedRangeDataRecord } from '@sofa-platform/types'

import { rangeDataQueryOptions } from '@/query-options'

import { useSettingsAndTranslations } from './use-settings-and-translations'

export function useRangeData(rangeId: string): UseSuspenseQueryResult<EnrichedRangeDataRecord[number]>
export function useRangeData(): UseSuspenseQueryResult<EnrichedRangeDataRecord>
export function useRangeData(
  rangeId?: string,
): UseSuspenseQueryResult<EnrichedRangeDataRecord | EnrichedRangeDataRecord[number]> {
  const { dexfSettings } = useSettingsAndTranslations()
  const { dev: isDev } = useSearch({ strict: false })
  return useSuspenseQuery({
    ...rangeDataQueryOptions(dexfSettings, isDev),
    select: useCallback(
      (data: EnrichedRangeDataRecord) => {
        return rangeId ? data[rangeId] : data
      },
      [rangeId],
    ),
  })
}
